export default {
    CUSTOMERS: '/dashboard/customers',
    CLIENTS: '/dashboard/clients',
    USERS: '/dashboard/users',
    INVOICES: '/dashboard/invoices',
    IMPORT: '/dashboard/imports',
    RESET: '/auth/reset',
    LOGIN: '/auth/login',
    DESIGN: '/design',
}